var Bundler = /* @__PURE__ */ ((Bundler2) => {
  Bundler2[Bundler2["rollup"] = 0] = "rollup";
  Bundler2[Bundler2["webpack"] = 1] = "webpack";
  return Bundler2;
})(Bundler || {});
var Theme = /* @__PURE__ */ ((Theme2) => {
  Theme2["ADMIN"] = "admin";
  Theme2["CARY"] = "cary";
  Theme2["LOOPIA"] = "loopia";
  Theme2["ACTIVE_24"] = "active24";
  return Theme2;
})(Theme || {});
var CompanyId = /* @__PURE__ */ ((CompanyId2) => {
  CompanyId2["WEBSUPPORT_SK"] = "sk-ws";
  CompanyId2["SK_WEBSUPPORT_CZ"] = "cz-ws";
  CompanyId2["WEBSUPPORT_HU"] = "hu-ws";
  CompanyId2["WEBSUPPORT_SE"] = "se-ws";
  CompanyId2["SK_WEBSUPPORT_HU"] = "hu-skws";
  CompanyId2["ACTIVE_24_SK"] = "sk-a24";
  CompanyId2["ACTIVE_24_CZ"] = "cz-a24";
  CompanyId2["SK_WEBSUPPORT_AT"] = "at-ws";
  CompanyId2["LOOPIA_SE"] = "se-lp";
  CompanyId2["LOOPIA_NO"] = "no-lp";
  return CompanyId2;
})(CompanyId || {});
export {
  Bundler,
  CompanyId,
  Theme
};
//# sourceMappingURL=config.enum.es.js.map
